/**
 * Created by Timur on 19.10.2026
 */

if (cleverapps.config.features.includes("playbutton")) {
    PlayButtonView.prototype.createButton = cleverapps.extendFunc(PlayButtonView.prototype.createButton, function () {
        if (this.isSmall || this.noLevelNumber || this.options.hard === false || this.getRoyalLeague() || !this.getDisplayedLevel().isSuperHard()) {
            this._super();
            return;
        }

        this.createContentButton();
    });

    PlayButtonView.prototype.createContentButton = function () {
        const styles = cleverapps.styles.PlayButtonView;

        if (this.button) {
            this.button.removeFromParent();
        }

        const button = this.button = new cleverapps.UI.Button({
            width: styles.width,
            height: styles.height,
            click_effect: true,
            content: this.getContent(),
            type: this.styling.type,
            onClicked: function () {
                cleverapps.effects.fire("playbutton.press");
                cleverapps.playButton.onClick();
            }
        });

        button.font = cleverapps.styles.FONTS.PLAY_BUTTON_TEXT;
        this.addChild(button);
        button.setAlignment(styles.button);
    };

    PlayButtonView.prototype.getContent = function () {
        return new cleverapps.Layout(this.getContentItems(), {
            direction: cleverapps.UI.VERTICAL,
            margin: cleverapps.styles.PlayButtonView.margin,
            padding: cleverapps.styles.PlayButtonView.padding
        });
    };

    PlayButtonView.prototype.getContentItems = function () {
        const levelNo = cleverapps.playButton.getLevelNo();
        const level = this.getDisplayedLevel();
        const msg = Messages.get("PlayButton.text", { levelNo });

        const text = cleverapps.UI.generateOnlyText(msg, cleverapps.styles.FONTS.PLAY_BUTTON_TEXT);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);

        const items = [text];

        if (level.isHard()) {
            const hardText = cleverapps.UI.generateOnlyText(
                Messages.get(level.isSuperHard() ? "message.superHardLevel" : "message.hardLevel", { levelNo }),
                cleverapps.styles.FONTS.PLAY_BUTTON_HARD_TEXT
            );
            hardText.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
            items.push(hardText);
        }

        return items;
    };
}
